/**
 * Requests by `source_service`.
 *
 * Answerable at all only because every queue message carries the field. The
 * incumbent defaulted it to "unknown", and on 2026-07-27 that bucket absorbed
 * 5.4 M of the day's 6.7 M completed channels — making per-use-case cost
 * unattributable exactly when someone needed to know it.
 */
import { useAttribution } from '../api/queries'
import { Bar, PanelState, Tile } from '../components/ui'
import { n, pct } from '../components/format'

export function Attribution() {
  const { data, isLoading, error } = useAttribution()
  return (
    <Tile title="Requests by lane" hint="today · RapidAPI quota ledger">
      <PanelState isLoading={isLoading} error={error}>
        {!data?.total
          ? <p className="panel-load">no attributed spend yet today</p>
          : (
            <div className="dist">
              {data.sources.map((s) => (
                <div className="dist-r" key={s.source}>
                  <span>{s.source}</span>
                  <Bar pct={s.pct} />
                  <span className="dist-n tnum">{n(s.requests)}</span>
                  <span className="dist-p tnum q">{pct(s.pct)}</span>
                </div>
              ))}
            </div>
          )}
      </PanelState>
    </Tile>
  )
}
